import {DownloadExcel} from "./excelUtils.js";
import common from "@well-b/well-b-shared";

export const ExportToExcel = async ({sheetsConfig, fileName}) => {
    const {workbook} = common.exportToExcel({sheetsConfig});
    await DownloadExcel(workbook, fileName);
};
